import React, { useState } from "react";
import { connect } from "react-redux";
import { toggleLoading } from "../../../state/creators";
import { Props } from "../../../_interfaces/data.reset1Form.interface";
import { UserReset1Model } from "../../../_models/data.userReset1.model";
import { ApiResultModel } from "../../../_models/api.result.model";
import { ValidateReset1 } from "../../../functions/validators";
import { Reset1 } from "../../../functions/http-functions/auth";
import Text from "../inputs/text";
import FormError from "../errors/http";
import { Form } from "../../../styles/forms";
import { ButtonList, SubmitButton } from "../../../styles/type/buttons";
import { AssistiveText, Cta } from "../../../styles/type/typography";
import { IHttpResponse } from "../../../functions/http-functions/http";
import { useRouter } from "next/router";

const ResetForm: React.FC<Props> = ({ toggleLoading }) => {
	const [state, setState] = useState(new UserReset1Model());
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);

	const router = useRouter();

	const handleChange = ({ target: { name, value } }) => {
		setState((prevState) => ({ ...prevState, [name]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setState((prevState) => ({ ...prevState, emailError: null }));
		const ValidateStep = ValidateReset1({ ...state });
		if (ValidateStep.valid) {
			reset();
		} else {
			for (let i = 0, item; !!(item = ValidateStep.errors[i++]); ) {
				setState((prevState) => ({
					...prevState,
					[item.name]: item.error,
				}));
			}
		}
	};

	const reset = async () => {
		toggleLoading(true);
		Reset1(new UserReset1Model({ ...state }))
			.then((res) => setSuccess(true))
			.catch((err: unknown) => {
				const error = err as IHttpResponse;
				const ErrorResult = new ApiResultModel(error);
				setError(<FormError errors={[ErrorResult.message]} />);
			})
			.then(() => toggleLoading(false));
	};

	return (
		<>
			{success ? (
				<>
					<AssistiveText>
						<p>Thank you. If an account associated with the email entered exists you will receive an email with instructions for resetting your password.</p>
					</AssistiveText>
					<ButtonList justify={"center"}>
						<Cta center onClick={() => router.push("/about")}>
							Return to Home
						</Cta>
					</ButtonList>
				</>
			) : (
				<Form>
					<Text name="email" label="Email Address" value={state.email} onChange={handleChange} error={state.emailError} required={true} autoCapitalize="none" />
					{error}
					<ButtonList justify={"space-between"}>
						<Cta center onClick={() => router.push("/login")}>
							Back to Login
						</Cta>
						<div>
							<SubmitButton onClick={handleSubmit} full>
								Reset
							</SubmitButton>
						</div>
					</ButtonList>
				</Form>
			)}
		</>
	);
};

const mapDispatchToProps = {
	toggleLoading,
};

export default connect(null, mapDispatchToProps)(ResetForm);
